var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalibrationBoardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83333 4H5.5V6.33333H7.83333V4Z",
    fill: "#4D5874"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5013 4H10.168V6.33333H12.5013V4Z",
    fill: "#4D5874"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1673 4H14.834V6.33333H17.1673V4Z",
    fill: "#4D5874"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9508 1.04999H1.05078V19.95H19.9508V1.04999ZM17.5008 19.7167V17.5H15.1674V19.7167H12.8341V17.5H10.5008V19.7167H8.16745V17.5H5.83411V19.7167H3.50078V17.5H1.28411V15.1667H3.50078V12.8333H1.28411V10.5H3.50078V8.16665H1.28411V5.83332H3.50078V3.49999H1.28411V1.28332H3.50078V3.49999H5.83411V1.28332H8.16745V3.49999H10.5008V1.28332H12.8341V3.49999H15.1674V1.28332H17.5008V3.49999H19.7174V5.83332H17.5008V8.16665H19.7174V10.5H17.5008V12.8333H19.7174V15.1667H17.5008V17.5H19.7174V19.7167H17.5008Z",
    fill: "#4D5874"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 5.83319H3.5V8.16652H5.83333V5.83319Z",
    fill: "#4D5874"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4993 5.83319H8.16602V8.16652H10.4993V5.83319Z",
    fill: "#4D5874"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1673 5.83319H12.834V8.16652H15.1673V5.83319Z",
    fill: "#4D5874"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16536 8.16656H5.83203V10.4999H8.16536V8.16656Z",
    fill: "#4D5874"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 8.16656H10.5V10.4999H12.8333V8.16656Z",
    fill: "#4D5874"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5013 8.16656H15.168V10.4999H17.5013V8.16656Z",
    fill: "#4D5874"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 10.5H3.5V12.8333H5.83333V10.5Z",
    fill: "#4D5874"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4993 10.5H8.16602V12.8333H10.4993V10.5Z",
    fill: "#4D5874"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1673 10.5H12.834V12.8333H15.1673V10.5Z",
    fill: "#4D5874"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.16536 12.8334H5.83203V15.1668H8.16536V12.8334Z",
    fill: "#4D5874"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8333 12.8334H10.5V15.1668H12.8333V12.8334Z",
    fill: "#4D5874"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5013 12.8334H15.168V15.1668H17.5013V12.8334Z",
    fill: "#4D5874"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 15.1668H3.5V17.5001H5.83333V15.1668Z",
    fill: "#4D5874"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4993 15.1668H8.16602V17.5001H10.4993V15.1668Z",
    fill: "#4D5874"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1673 15.1668H12.834V17.5001H15.1673V15.1668Z",
    fill: "#4D5874"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0V21H21V0H0ZM20.4167 20.4167H0.583333V0.583333H20.4167V20.4167Z",
    fill: "#4D5874"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalibrationBoardIcon);
export default __webpack_public_path__ + "static/media/calibration_board_icon.76a33ac4cefced17d9957fbfb0150145.svg";
export { ForwardRef as ReactComponent };